import Chart from "react-apexcharts";
import { colors } from "../../GlobalDashboardPage";

export interface IVerticalChartProps {
  data: number[];
  categories: string[];
  seriesName: string;
}

const HorizontalBarChart = ({ data, categories, seriesName }: IVerticalChartProps) => {
  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: true,
        borderRadius: 6,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    grid: {
      show: false,
    },
    colors: Object.values(colors),
    legend: {
      show: false,
    },
    tooltip: {
      enabled: true,
    },
  };

  const series = [
    {
      name: seriesName.charAt(0).toUpperCase() + seriesName.slice(1),
      data: data,
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={"90%"}
    />
  );
};

export default HorizontalBarChart;
